import tinycolor, { Instance as TinyColor } from 'tinycolor2'
import Button from "@mui/material/Button"
import { memo, useCallback, useMemo } from "react"
import useStyles from './styles'

export type ColorSwatchProps = {
    onClick: (color: TinyColor) => void,
    value: TinyColor,
    selected?: boolean
}


const ColorSwatch: React.FC<ColorSwatchProps> = ({value, selected  = false, onClick}) => {
    const clickHandler = useCallback(() => onClick(value), [onClick, value])
    const { classes, cx } = useStyles()
    const sx = useMemo(() => ({
        color: value.toRgbString(),
        background: value.toRgbString()
    }), [value])
    return <Button className={cx(classes.root, {[classes.selected]: selected})} onClick={clickHandler} sx={sx} disableElevation disableRipple ></Button>
}

export default memo(ColorSwatch)